import React, { Component } from "react";
import View from "./view";
import { getNearbyStores } from "../../../backend/stores";
import "./index.css";
import withRouter from "react-router-dom/withRouter";
import PropTypes from "prop-types";
import { updateRoute } from "../../../redux/actions";
import { connect } from "react-redux";
import { geocodeCoords } from "../../../backend/geocode";

class NearbyStores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formattedAddress: "",
      postalCode: "",
      collapsed: true,
      loading: false
    };
    this._navigate = this._navigate.bind(this);
    this._renderStore = this._renderStore.bind(this);
  }

  async componentDidMount() {
    if ("geolocation" in navigator) {
      this.setState({ loading: true });

      navigator.geolocation.getCurrentPosition(async position => {
        let address = await geocodeCoords(
          position.coords.latitude,
          position.coords.longitude
        );

        address = address.results;

        let postCode = address[0].address_components.find(({ types }) =>
          types.includes("postal_code")
        ).long_name;

        let formattedAddress = address[1].formatted_address;

        this.setState({
          nearbyStores: await getNearbyStores({ postCode }),
          postCode,
          formattedAddress,
          locationServicesEnabled: true,
          loading: false
        });
      });
    } else {
      this.setState({ locationServicesEnabled: false });
    }
  }

  _renderStore({ name, id }, index) {
    return (
      <div
        className="list-item"
        onClick={() => this._selectStore(id)}
        key={index}
      >
        {name}
      </div>
    );
  }

  _selectStore(id) {
    this._navigate(`/${this.props.baseUrl}/${id}`)();
    this.setState({ collapsed: true });
    this.props.updateRoute(id);
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }

  render() {
    return View.call(this);
  }
}

NearbyStores.propTypes = {
  baseUrl: PropTypes.string.isRequired
};

NearbyStores.defaultProps = {
  baseUrl: "stores"
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateRoute: store_id => {
      dispatch(updateRoute("stores", `/stores/${store_id}`));
      dispatch(updateRoute("machines", `/machines/${store_id}`));
      dispatch(updateRoute("create", `/comment-form/${store_id}`));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NearbyStores)
);



// WEBPACK FOOTER //
// ./src/screens/stores/nearby-stores/index.js